export const createDOMElement = (
  type,
  { attributes, events, innerHTML } = {}
) => {
  const el = document.createElement(type);
  if (attributes) {
    Object.keys(attributes).forEach(key =>
      el.setAttribute(key, attributes[key])
    );
  }
  if (events) {
    Object.keys(events).forEach(key => el.addEventListener(key, events[key]));
  }
  if (innerHTML) {
    el.innerHTML = innerHTML;
  }
  return el;
};

export const addScript = (src, { attributes, events } = {}) => {
  const script = createDOMElement('script', {
    attributes: { ...attributes, src },
    events
  });
  document.head.appendChild(script);
};

const addedStyles = new Set();
export const addStyle = cssDeclarations => {
  if (!addedStyles.has(cssDeclarations)) {
    addedStyles.add(cssDeclarations);
    const style = createDOMElement('style', {
      innerHTML: cssDeclarations
    });
    document.head.appendChild(style);
  }
};

export const isElementVisible = (el, percentVisible = 0) => {
  const rect = el.getBoundingClientRect();
  return !(
    Math.floor(
      100 - ((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100
    ) < percentVisible ||
    Math.floor(100 - ((rect.bottom - window.innerHeight) / rect.height) * 100) <
      percentVisible
  );
};

export const gebi = id => document.getElementById(id);
